export default __webpack_public_path__ + "static/back-be61dbc80cbf424086eb9c8d0b80703d.png";